import { Link } from 'react-router-dom';
import { v } from '@/theme/tokens';

export function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        background: v('bg'),
      }}
    >
      <div style={{ fontSize: 40, fontWeight: 700 }}>404</div>
      <div style={{ color: v('ink-muted') }}>Страница не найдена</div>
      <Link to="/">Вернуться на обзор</Link>
    </div>
  );
}
